import { Button } from "@unified-checkout/design-system";
import type { IInfoChip } from "@app/dashboard/types/innerLayout/info-chip";
import styles from "./info-chip.module.scss";

export const InfoChip = ({
  width,
  text,
  hintText,
  btnsProps
}: IInfoChip) => {
  return (
    <div
      className={styles["info-chip"]}
      style={{ width }}
    >
      <div className={styles["info-chip__text-box"]}>
        <div className={styles["info-chip__text-box__text"]}>
          {text}
        </div>

        {
          hintText &&
          <div className={styles["info-chip__text-box__hint-text"]}>
            {hintText}
          </div>
        }
      </div>

      {
        btnsProps &&
        <div className={styles["info-chip__action-btns"]}>
          {
            btnsProps.map((btn, index) =>
              <Button
                key={`info-chip-action-btn-${index}`}
                {...btn}
                size="md"
                variant="outlined"
                onClickHandler={btn.onClickHandler}
              />
            )}
        </div>
      }
    </div>
  )
}
